export default __webpack_public_path__ + "static/media/giftBox.51d2c833.svg";